import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Level
name: Level
category: React - Bulma
---

A `Level` component based on Bulma `.level`. This should be used with `LevelLeft`,
`LevelRight`, and `LevelItem` components.

See [Bulma Documentation](http://bulma.io/documentation/components/level/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                 |Type            | Default Value             | Required?     |
|-----------------|---------------------------------------------|----------------|---------------------------|---------------|
| isMobile        | Level begins on mobile devices              | boolean        | false                     | no            |
| isTablet        | Level begins on tablet devices              | boolean        | true                      | no            |
| isDesktop       | Level begins on desktop devices             | boolean        | false                     | no            |
| isFullwidth     | Level fills the parent's width              | boolean        | false                     | no            |

```html_example
  <Level>
    <LevelLeft>
      ...
    </LevelLeft>
    <LevelRight>
      ...
    <LevelRight>
  </Level>
```
*/
function Level(props) {
  const {
    children, className, isMobile, isTablet, isDesktop, isFullwidth, ...rest
  } = props

  const classes = [
    'level',
    className || '',
    isMobile ? 'is-mobile' : '',
    isTablet ? 'is-tablet' : '',
    isDesktop ? 'is-desktop' : '',
    isFullwidth ? 'is-fullwidth' : '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

Level.defaultProps = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isFullwidth: false,
}

Level.propTypes = {
  // Children components are always adjacent.
  isMobile: PropTypes.bool,
  // Children components are adjacent starting on tablet.
  isTablet: PropTypes.bool,
  // Children components are adjacent starting on desktop.
  isDesktop: PropTypes.bool,
  // Level Fills the parent's width
  isFullwidth: PropTypes.bool,
}

export default Level
